export function getQuestionLabel(question) {
    return question
        ? `Q${question.data?.label ?? question.data?.sequence ?? ''}`
        : 'Q';
}
